<div class="prs-auth-modal-panel prs-auth-demo-credentials" data-testing-id="demo-credentials-modal">
  <div class="modal-header">
    <h2 class="modal-title" id="prs-auth-modal-demo-title">
      {{ 'login.demo_title' | translate }}
    </h2>
    <button
      type="button"
      class="btn-close"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <p class="prs-auth-demo-credentials__hint text-muted">{{ 'login.demo_hint' | translate }}</p>

    <div class="prs-auth-demo-credentials__groups">
      @for (group of accountGroups; track group.id) {
      <section class="prs-auth-demo-group" [attr.data-testing-id]="'demo-credentials-group-' + group.id">
        <h3 class="prs-auth-demo-group__title">{{ group.titleKey | translate }}</h3>

        <div class="prs-auth-demo-table" role="list">
          <div class="prs-auth-demo-table__head" aria-hidden="true">
            <span>{{ 'login.demo_col.role' | translate }}</span>
            <span>{{ 'login.demo_col.credentials' | translate }}</span>
            <span>{{ 'login.demo_col.affiliate' | translate }}</span>
            <span>{{ 'login.demo_col.approval' | translate }}</span>
            <span>{{ 'login.demo_col.approver' | translate }}</span>
            <span>{{ 'login.demo_col.purchase_rule' | translate }}</span>
          </div>

          @for (account of group.accounts; track account.id) {
          <button
            type="button"
            class="prs-auth-demo-table__row"
            role="listitem"
            (click)="select(account)"
            [attr.aria-label]="account.fillAriaKey | translate"
            [attr.data-testing-id]="'demo-credentials-' + account.id"
          >
            <span class="prs-auth-demo-table__role">{{ account.roleKey | translate }}</span>
            <span class="prs-auth-demo-table__creds">
              <code class="prs-auth-demo-table__email">{{ account.login }}</code>
              <code class="prs-auth-demo-table__password">{{ account.password }}</code>
            </span>
            <span class="prs-auth-demo-table__affiliate">{{ account.affiliateKey | translate }}</span>
            <span class="prs-auth-demo-table__approval" [attr.data-approval]="account.approvalKey">{{
              account.approvalKey | translate
            }}</span>
            <span class="prs-auth-demo-table__approver">{{ account.approverOfKey | translate }}</span>
            <span class="prs-auth-demo-table__rules">{{ account.purchaseRuleKey | translate }}</span>
          </button>
          }
        </div>
      </section>
      }
    </div>
  </div>
</div>
